export const JUSTIFICACIONES_LIBERACION = [
    {
        id: 'override_falso_positivo',
        label: 'Falso positivo en listas',
        action: 'set_risk_level_1',
        notification_24_hours: false,
    },
    {
        id: 'override_gatekeepers',
        label: 'Info. Persona es gatekeeper',
        action: 'set_risk_level_1',
        notification_24_hours: false,
    },
    {
        id: 'confirmation_pep_nacional',
        label: 'Confirmación de Persona Politicamente Expuesta Nacional/Local',
        action: 'set_risk_level_2',
        notification_24_hours: true,
    },
    {
        id: 'confirmation_pep_internacional',
        label: 'Confirmación de Persona Politicamente Expuesta Internacional',
        action: 'set_risk_level_3',
        notification_24_hours: true,
    },
    {
        id: 'override_autorizacion_superior',
        label: 'Autorización de instancia superior documentada',
        action: 'set_risk_level_3',
        notification_24_hours: true,
    },
    {
        id: 'confirmation_coincidencia_confirmada',
        label: 'Confirmación de Coincidencia',
        action: 'set_risk_level_3',
        notification_24_hours: true,
    }
];